import { Category } from '../types/content'

export const categories: Category[] = [
  {
    slug: 'weight-metabolic',
    name: 'Weight & Metabolic',
    tagline: 'GLP-1s and metabolic support',
    description:
      'For appetite that will not quit, weight that will not move, and blood sugar that is heading the wrong way. Every plan pairs the medication with bloodwork, so you find out whether it is working instead of guessing.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/988bf5b0-56fe-4a57-805e-a474069d2bba.jpg',
    outcomes: ['Weight that stays off', 'Better blood sugar', 'Muscle you keep'],
  },
  {
    slug: 'recovery-repair',
    name: 'Recovery & Repair',
    tagline: 'Tendons, gut and inflammation',
    description:
      'For the injury that never fully healed and the inflammation underneath it. These are the peptides athletes and physios talk about, prescribed properly and made by a pharmacy you can name.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/34402946-009c-410c-a5d5-9bc6ac8f89bd.jpg',
    outcomes: ['Faster recovery', 'Less inflammation', 'A calmer gut'],
  },
  {
    slug: 'growth-hormone',
    name: 'Growth Hormone',
    tagline: 'Secretagogues, not replacement',
    description:
      'These do not hand you growth hormone. They nudge your own pituitary to release it on its normal nightly rhythm, which is why they are dosed at bedtime and cycled with time off.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a1748c91-5393-4f90-8559-55f6bc8492a0.jpg',
    outcomes: ['Sleep that restores', 'Leaner composition', 'Recovering like you used to'],
  },
  {
    slug: 'longevity-cellular',
    name: 'Longevity & Cellular',
    tagline: 'Energy at the cellular level',
    description:
      'For the tiredness that sleep does not fix. These work on the machinery underneath how you feel day to day — mitochondria, oxidative stress, and the repair systems that slow down with age.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/16eed9e3-66cf-4182-8f79-1078f5dc7790.jpg',
    outcomes: ['Energy that lasts the day', 'Less oxidative stress', 'Better cellular repair'],
  },
  {
    slug: 'cognitive-mood',
    name: 'Cognitive & Mood',
    tagline: 'Focus, stress and clarity',
    description:
      'Nasal sprays for the days you cannot hold a thought, and for a stress response stuck in the on position. Short courses, checked in on before anyone renews them.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e2180611-141f-4ab0-9ba3-4de7dac91f2e.jpg',
    outcomes: ['Sharper focus', 'A calmer baseline', 'More even mood'],
  },
  {
    slug: 'skin-hair',
    name: 'Skin & Hair',
    tagline: 'Collagen, repair and appearance',
    description:
      'Copper peptides and combination stacks for skin that has lost its bounce, scarring that has stuck around, and hair that is thinning. Topical if you would rather not inject.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a4fe5225-7444-404d-bbf6-f04c61a8bf04.jpg',
    outcomes: ['Firmer skin', 'More collagen', 'Healthier scalp'],
  },
]

export function getCategory(slug: string): Category | undefined {
  return categories.find((category) => category.slug === slug)
}
